<template lang="pug">
  .rss-order-content
    order-overview(:order="order")
    .rss-columns-wrapper
      Row.rss-columns(align-items="stretch")
        Column(mobile="12" desktop="4")
          order-status(
            :current-package="currentPackage"
            :delivery-address="order.deliveryAddress"
            :email="order.email"
          )
        Column(mobile="12" desktop="4" v-if="currentPackage.items && currentPackage.items.length > 0")
         | #[items-shipped(:current-package="currentPackage")]
        Column(mobile="12" desktop="4") #[toggle-blocks(:order="order")]
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, watch } from 'vue'
import { type LocationQueryValue, useRoute } from 'vue-router'
import OrderOverview from '../components/order-overview.vue'
import OrderStatus   from '../components/block-order-status.vue'
import ItemsShipped  from '../components/block-items-shipped.vue'
import ToggleBlocks  from '../components/block-toggle-blocks.vue'
import type { TrackedOrder, IRssPackage, IRssResponse } from '../rssTypes'

const props = defineProps<{
  orderData: IRssResponse,
}>()

const route = useRoute()

const currentPackage = ref<Partial<IRssPackage>>({})

const order = computed<TrackedOrder>(() => {
  const { data: { packages, delivery_address, sourceOrderId }, email } = props.orderData

  const order = {
    email,
    packages,
    isPickup             : currentPackage.value?.isPickup || false,
    orderNumber          : sourceOrderId || '',
    deliveryAddress      : delivery_address || '',
    currentPackageStatus : currentPackage.value?.status,
  }

  return order
})

function setCurrentPackage(packageId: LocationQueryValue | LocationQueryValue[]): void {
  const idAsNum = Number(packageId)
  const index = (!isNaN(idAsNum) && idAsNum > 0) ? (idAsNum - 1) : 0
  currentPackage.value = props.orderData.data?.packages?.[index] || {}
}

watch(() => route.query.packageId, (packageId) => {
  setCurrentPackage(packageId)
})

onBeforeMount(() => {
  const { query: { packageId } } = route
  setCurrentPackage(packageId)
})
</script>

<style lang="scss" scoped>
  .rss-order-content {
    margin-bottom: $space-xxxxl;
  }

  .rss-columns-wrapper {
    padding    : $space-s $space-s 0 $space-s;
    background : $color-gray-x-light;
  }
</style>
